<template>
  <div>
  <Breadcrumbs main="Services" title="ATM & Branch Locator" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12 col-md-12 box-col-12">
          <div class="file-content">
            <div class="card">
              <div class="card-header">
                <h5 style="font-weight: 400">ATM & Branch Locator</h5>
                <span>Locate any ATM and Branch closer to you.</span>
              </div>
              <div id="RequestFormSection" class="animated fadeIn">
                  <div class="card-body">
                    <Markers></Markers>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
  import { mapState } from 'vuex';
  import Markers from './maps/markers';
  export default {
    components: {
      Markers
    },
    data:() => ({
      
    }),
    computed: {
      ...mapState({
        // eslint-disable-next-line no-confusing-arrow
        getAllBranches: state => state.requests ? state.requests.allBranches : [],
      }),
    },
    methods : {
    }
  };
</script>
<style scoped>
.file-content .card .card-header,
.file-content .card .card-body {
  padding: 40px !important;
}
.card .card-header h5 {
    font-size: 23px;
    font-weight: 300;
}
.btn-light {
    background-color: #e6e6e6 !important;
    color: #000000!important;
    /* border-color: rgba(228, 31, 19, 0.06) !important; */
}
.theme-form select.acct-num {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100%;
}
.form-control {
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  width: 100% !important;
}
.form-select {
  width: 100%;
  border-color: #efefef;
  background-color: #f7f7f7;
  font-size: 14px;
  color: #898989;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem
}
.form-control::placeholder {
  color: #898989;
}
.pull-right {
  color:#E41613;
}
.btn-outline-danger {
  border-color: #e6e6e6;
  color: #000;
  margin-left: 5px;
}
.swal2-actions >>> .swal2-confirm {
  background-color: #1a803f !important;
}
.loader-12 {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5) url("../../assets/TAJimages/backgrounds/taj_loader_sm.gif") center center no-repeat;
  z-index: 1000;
  border-radius: 10px;
}
.vdp-datepicker {
  width: 485px !important;
}
</style>